<template>
  <div>
    <el-dialog
      v-model="dialogStatus"
      :title="creativeTitle"
      :close-on-click-modal="false"
      @close="close"
      width="50%"
      append-to-body
    >
      <div >
        <el-select
          v-model="formCommon.dspId"
          @change="getDspSlotName"
          clearable
          :disabled="isDisabled"
          filterable

          style="width:100%"
          placeholder="请选择DSP名称"
        >
          <el-option
            v-for="item in dspNameOptions"
            :key="item.dspId"
            :label="item.dspName"
            :value="item.dspId"
          />
        </el-select>
      </div>
      <div style="margin:10px 0">
        <el-select v-model="formCommon.dspSlotId"
                   filterable
                   :disabled="isDisabled"
                   clearable
                   remote
                   style="width:100%"
                   :remote-method="getDspSlotName"
                    placeholder="请选择DSP广告位">
          <el-option v-for="item in dspSlotOptions" :key="item.dspSlotId" :label="item.dspSlotName"
                     :value="item.dspSlotId"/>
        </el-select>
      </div>
      <div>
        <p>创意类型</p>
        <el-radio-group
          v-model="formCommon.ideaType"
          :disabled="isDisabled"
        >
          <el-radio v-for="item in ideaTypeList"
                    :label="item.value"
                    :key="item.value">{{ item.lable }}
          </el-radio>
        </el-radio-group>
      </div>
      <div>
        <p>上传创意</p>
        <div style="margin-bottom: 20px">
          <el-radio v-model="formCommon.ideaStyle" :label="1" border :disabled="isDisabled">图片</el-radio>
          <el-radio v-model="formCommon.ideaStyle" :label="2" border :disabled="isDisabled">url链接</el-radio>
          <el-button size="small" @click="addTab" :disabled="ideaId">
            新增创意组
          </el-button>
        </div>
        <el-tabs
          v-model="editableTabsValue"
          type="card"
          closable
          @tab-remove="removeTab"
        >
          <el-tab-pane
            v-for="(item, index) in formAd"
            :key="index"
            :label="'创意' + (index + 1)"
            :name="index"
          >
            <el-form
              :rules="rules"
              :model="formAd[index]"
              ref="formAd"
              label-position="left"
              label-width="110px"
            >
              <div>
                <el-form-item v-if="formCommon.ideaStyle===1">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="header"
                    list-type="picture-card"
                    :limit="3"
                    :file-list="fileList"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(value) => handleSuccess(index, value)"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="(value)=>handleRemove(index,value)"
                    accept="image/*,video/*"
                  >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <el-dialog v-model="dialogVisible">
                    <!-- <img
                     v-if="formAd[index].imgUrls"
                     :src="$imgUrls + '/' +formAd[index].imgUrls[0]"
                     class="avatar"
                     style=""
                   />
                    <video v-else-if="formAd[index].videoUrl"
                         :src="$imgUrls+'/'+formAd[index].videoUrl"
                         muted
                         controls="controls">
                       您的浏览器不支持视频播放
                   </video> -->
                    <el-image :src="dialogImageUrl" alt="" width="300"/>
                  </el-dialog>
                </el-form-item>
                <el-form-item v-else-if="formCommon.ideaStyle===2">
                  链接1：
                  <el-input v-model="formAd[index].linkUrls.url1" size="mini"></el-input>
                  链接2：
                  <el-input v-model="formAd[index].linkUrls.url2" size="mini"></el-input>
                  链接3：
                  <el-input v-model="formAd[index].linkUrls.url3" size="mini"></el-input>
                </el-form-item>
                <div
                  v-if="
                    formCommon.ideaType !== 2 &&
                    formCommon.ideaType !== 3
                  "
                >
                  <el-form-item label="标题" :rules="ideaTitle" prop="ideaTitle">
                    <el-input v-model="formAd[index].ideaTitle"></el-input>
                  </el-form-item>
                  <el-form-item label="描述">
                    <el-input v-model="formAd[index].ideaDesc"></el-input>
                  </el-form-item>
                </div>
                <el-form-item
                  label="落地页"
                  :rules="landConfirm"
                  prop="landingPage"
                >
                  <el-input v-model="formAd[index].landingPage"></el-input>
                </el-form-item>
                <el-form-item label="DP地址">
                  <el-input v-model="formAd[index].dpAddress"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div style="text-align: right">
        <el-button @click="close" >取消</el-button>
        <el-button
          @click="submit"
          type="primary"

          :loading="submitLoading"
        >保存
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCreative,
  updataCrerative,
  getCreative,
  getId,
  getTemplate
} from '@/api/manage/creative/creative'
import { ideaTypeList } from '@/const/idea-type'
import { mapGetters } from 'vuex'
import { getDspName, getDspSlotName } from '@/api/select'

const formCommon = {
  dspId: undefined,
  dspSlotId: undefined,
  taskId: undefined,
  ideaType: undefined,
  ideaStyle: 1
}
const formAdItem = {
  imgUrls: [],
  linkUrls: { url1: '', url2: '', url3: '' },
  ideaTitle: undefined,
  ideaDesc: undefined,
  landingPage: undefined,
  dpAddress: undefined
}
export default {
  components: {},
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      formCommon: Object.assign({}, formCommon), // 先初始默认值，避免报错
      formAd: [formAdItem],
      ideaTypeList,
      ideaId: undefined,
      planData: undefined,
      template: [],
      header: {},
      rules: {
        ideaTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      },
      Need: [{ required: true, message: '请提供落地页', trigger: 'blur' }],
      noNeed: [{ required: false }],
      isDisabled: false,
      editableTabsValue: 0,
      tabIndex: 1,
      norms: undefined,
      isImgurl: true,
      uploadUrl: undefined,
      isImgSize: true,
      big: undefined,
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      dspSlotOptions: [],
      dspNameOptions: []
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
    getId().then((res) => {
      this.planData = res.data
    })
    getTemplate().then((res) => {
      this.template = res.data
    })
    this.getDspName()
  },
  computed: {
    ...mapGetters(['access_token']),
    landConfirm () {
      if (
        this.formCommon.ideaType !== 2 &&
        this.formCommon.ideaType !== 3
      ) {
        return this.noNeed
      } else {
        return this.Need
      }
    },
    creativeTitle () {
      return (this.ideaId ? '修改' : '新增') + '创意'
    }
  },
  methods: {
    show (data) {
      if (data) {
        this.ideaId = data.ideaId
        this.isDisabled = true
        getCreative({ ideaId: data.ideaId }).then((res) => {
          if (res.code === 200) {
            this.dataToForm(res.data)
          }
        })
      }
      this.dialogStatus = true
    },
    getDspName () {
      getDspName().then(res => {
        if (res.code === 200) {
          this.dspNameOptions = res.data
        }
      })
    },
    getDspSlotName () {
      // this.formCommon.dspSlotId = undefined
      getDspSlotName({ dspId: this.formCommon.dspId, slotIsEnable: false }).then(res => {
        if (res.code === 200) {
          this.dspSlotOptions = res.data
          this.dspSlotOptions.map((item) => {
            item.dspSlotName = item.dspSlotName + '-' + item.dspSlotCode
          })
        }
      })
    },
    close () {
      this.editableTabsValue = 0
      this.tabIndex = 1
      this.reset()
      this.dialogStatus = false
      this.isDisabled = false
    },
    reset () {
      this.formCommon = Object.assign({}, formCommon)
      this.formAd = [Object.assign({}, formAdItem)]
      this.fileList = []
      this.ideaId = undefined
    },
    /*  接口详情数据处理成Form */
    dataToForm (data) {
      this.formAd = [] // 先清空默认值
      const { dspId, dspSlotId, ideaType, taskId, ideaStyle } = data
      this.formCommon = { dspId, dspSlotId, ideaType, taskId, ideaStyle }
      let { imgUrls, ideaTitle, ideaDesc, landingPage, dpAddress, linkUrls } = data
      if (imgUrls) {
        imgUrls.forEach((item) => {
          this.fileList.push({ url: this.$imgURL + item })
        })
      }
      let linkList = {}
      if (linkUrls) {
        linkList.url1 = linkUrls[0] ? linkUrls[0] : ''
        linkList.url2 = linkUrls[1] ? linkUrls[1] : ''
        linkList.url3 = linkUrls[2] ? linkUrls[2] : ''
      } else {
        linkList = { url1: '', url2: '', url3: '' }
      }
      linkUrls = linkList
      this.formAd.push({ imgUrls, ideaTitle, ideaDesc, landingPage, dpAddress, linkUrls })
      this.getDspSlotName()
    },
    submit () {
      this.validate((valid) => {
        if (valid) {
          if (this.ideaId) {
            this.updataCrerative()
          } else {
            this.addCreative()
          }
        }
      })
    },
    validate (callback) {
      const isValid = true
      for (let i = 0; i < this.formAd.length; i++) {
        if (this.formAd[i].imgUrls || this.formAd[i].videoUrl) {
          if (this.isImgSize) {

          } else {
            this.$message.warning('创意图尺寸不匹配')
          }
        } else {
          this.$message.warning('请上传创意图')
        }
        callback(isValid)
      }
    },
    restrict (id) {
      var stand = this.template[id]
      if (stand) {
        this.norms = stand.imgStandard.split('x')
        this.big = Number(stand.imgSize)
      }
    },
    // 限制图片
    beforeAvatarUpload (file) {
      this.isImgSize = true
      if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) !== -1) {
        this.isImgurl = true
        //  this.limitFileWH(this.norms[0],this.norms[1], file).then((res) => {
        //   file.isFlag = res
        //   })
        return new Promise(resolve => {
          this.uploadUrl = process.env.VUE_APP_BASE_API + '/common/upload/image'
          resolve()
        })
      } else if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) !== -1) {
        this.isImgurl = false
        return new Promise(resolve => {
          this.uploadUrl = process.env.VUE_APP_BASE_API + '/common/upload/file'
          resolve()
        })
      } else {
        return false
      }
    },
    /* form处理提交数据 */
    formToData () {
      let data = {}
      if (this.ideaId) {
        data = Object.assign({}, this.formCommon)
        data = Object.assign(data, this.formAd[0])
        data.ideaId = this.ideaId
        if (data.ideaStyle === 2) {
          const linkList = []
          for (const i in data.linkUrls) {
            if (data.linkUrls[i]) {
              linkList.push(data.linkUrls[i])
            }
          }
          data.linkUrls = linkList
        } else {
          data.linkUrls = []
        }
        return data
      } else {
        data = Object.assign({}, this.formCommon)
        data.ideaGroupList = []
        this.formAd.forEach((item) => {
          if (data.ideaStyle === 2) {
            const linkList = []
            for (const i in item.linkUrls) {
              if (item.linkUrls[i]) {
                linkList.push(item.linkUrls[i])
              }
            }
            item.linkUrls = linkList
          } else {
            item.linkUrls = []
          }
          data.ideaGroupList.push(item)
        })
        return data
      }
    },
    addCreative () {
      addCreative(this.formToData())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    updataCrerative () {
      this.submitLoading = true
      updataCrerative(this.formToData())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    handleSuccess (index, value) {
      if (value.code === 200) {
        // this.fileList.push({url:this.$imgURL+value.data[0]})
        this.formAd[index].imgUrls.push(value.data[0])
        // if(this.isImgurl){
        // }else{
        //   this.formAd[index].imgUrls="";
        //   if(!this.formAd[index].videoUrl){
        //     this.formAd[index].videoUrl = value.data[0] || "";
        //   }else{
        //     this.formAd[index].videoUrl = "";
        //     this.formAd[index].videoUrl = value.data[0] || "";
        //   }
        // }
      }
    },
    handleRemove (index, file) {
      let num
      if (file.response) {
        num = this.formAd[index].imgUrls.indexOf(file.response.data[0])
      } else {
        const name = file.url.split('cn//')[1]
        num = this.formAd[index].imgUrls.indexOf(name)
      }
      this.formAd[index].imgUrls.splice(num, 1)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    addTab () {
      if (this.tabIndex < 5) {
        this.editableTabsValue = this.tabIndex++
        this.formAd.push({
          imgUrls: [],
          linkUrls: { url1: '', url2: '', url3: '' },
          ideaTitle: undefined,
          ideaDesc: undefined,
          landingPage: undefined,
          dpAddress: undefined
        })
      }
    },
    removeTab (targetName) {
      if (this.tabIndex > 1) {
        this.formAd.splice(targetName, 1)
        this.tabIndex = this.tabIndex - 1
        this.editableTabsValue = this.editableTabsValue - 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
  text-align: center;
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.big {
  width: 400px !important;
  height: 100%
}
</style>
